<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-body">
				<div *ngIf="leadLoading">
					<app-loading></app-loading>
				</div>
				<div class="row" *ngIf="!leadLoading && !lead">
					<div class="col-md-12 ml-auto mr-auto mb-2">
						<h4 class="text-danger"><i class="em em-warning"></i> {{ leadMsg }}</h4>
					</div>
				</div>
				<div class="row" *ngIf="!leadLoading && lead">
					<div class="col-md-12">
						<div class="row" *ngIf="fromCalendar">
							<div class="col-12 mb-2">
								<button type="button" class="btn btn-sm btn-outline-secondary" (click)="backToCalendar()">
									<i class="ri-arrow-left-line"></i> Back to Calendar
								</button>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<h4 style="position: relative; top: 20px; margin-top: 0px">Lead #{{ leadId }}</h4>
							</div>
						</div>
						<div class="row mt-4">
							<div class="col-md-12">
								<h2 class="campaign-row-title" style="margin-top: 0px">
									<small>
										<span
											class="badge"
											[ngClass]="{
												'bg-success': lead.lead_status == 'Approved',
												'bg-danger': lead.lead_status == 'Denied',
												'bg-info': lead.lead_status == 'Unreviewed',
												'bg-warning': lead.lead_status == 'Fix'
											}"
										>
											<span>{{ lead.lead_status }}</span>
										</span>
										{{ lead.prospect_company }} - {{ lead.campaign_name }}
									</small>
								</h2>
								<p *ngIf="lead.replacement_status != 'N/A' && lead.replacement_status != ''">
									Replacement or reschedule status:
									<span
										class="badge"
										[ngClass]="{
											'bg-danger': lead.replacement_status === 'Denied Reschedule',
											'bg-info': lead.replacement_status === 'Pending Reschedule' || lead.replacement_status === 'Rescheduled' || lead.replacement_status === 'Pending Replacement' || lead.replacement_status === 'Replaced',
											'bg-warning': lead.replacement_status === 'QC Calls' || lead.replacement_status === 'Reschedule Request'
										}"
									>
										{{ lead.replacement_status }}
									</span>
								</p>
								<p *ngIf="lead.customer_received === 'F'">The client hasn't confirmed receipt of the lead.</p>
								<p *ngIf="lead.customer_received === 'T'">The client confirmed receipt of the lead on {{ lead.received_date | utcToLocal : "longDate" }}</p>
							</div>
						</div>
					</div>
					<div class="row">&nbsp;</div>
					<ul class="nav nav-tabs mb-3" role="tablist" *ngIf="!leadLoading && lead">
						<li class="nav-item" role="presentation">
							<a class="nav-link" data-bs-toggle="tab" [ngClass]="{ active: activeTab === 'details' }" role="tab" aria-selected="false" tabindex="-1" (click)="activeTab = 'details'">Details</a>
						</li>
						<li class="nav-item" role="presentation">
							<a class="nav-link" data-bs-toggle="tab" [ngClass]="{ active: activeTab === 'call_sheet' }" role="tab" aria-selected="false" tabindex="-1" (click)="getCallSheet()">Call Sheet</a>
						</li>
					</ul>
					<div *ngIf="!leadLoading && lead" class="row">
						<ng-container *ngIf="activeTab === 'details'">
							<div *ngIf="leadLoading" class="text-center">
								<app-loading></app-loading>
							</div>
							<div class="col-md-12 ml-auto mr-auto">
								<h3 class="text-danger">{{ leadMsg }}</h3>
							</div>
							<div class="col-md-12 ml-auto mr-auto text-right">
								<div class="row">
									<div class="col-md-3 mb-3">
										<label class="float-left">Assigned To: {{ lead.campaign_id }}</label>
										<select class="form-control appt-select" [(ngModel)]="lead.campaign_id" #campaign_id="ngModel" ngControl="campaign_id" name="campaign_id">
											<option *ngFor="let campaign of activeCampaigns; let i = index" value="{{ campaign.id }}">{{ campaign.name }}</option>
										</select>
									</div>
								</div>
							</div>
							<div class="col-md-12 ml-auto mr-auto">
								<div class="row">
									<div class="col-md-5 col-sm-6">
										<div class="form-group">
											<label>Company Name</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-building-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.prospect_company" #prospect_company="ngModel" ngControl="prospect_company" name="prospect_company" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-2 mb-3">
										<label class="float-left">Primary Phone</label>
										<p style="font-size: 15px; font-weight: 800">
											<a href="tel:+1{{ lead.primary_phone }}" ngbTooltip="Click To Call" (click)="onPhoneClick(lead.primary_phone)">
												<i class="ri-phone-fill"></i> {{ lead.primary_phone | phone }}
											</a>
										</p>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label><i class="em em-spiral_calendar_pad mr-2"></i>Appt Date</label>
											<input [(ngModel)]="lead.start_date" #start_date="ngModel" ngControl="start_date" name="start_date" class="form-control border-input" placeholder="Start Date" type="date" disabled />
										</div>
									</div>
									<div class="col-md-2 col-sm-3">
										<div class="form-group">
											<label class="float-left"><i class="em em-clock1 mr-2"></i>Appt Time</label>
											<input type="text" value="{{ Time24To12(lead.start_date, lead.start_time) }}" class="form-control" disabled />
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>First Name</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-user-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.first_name" #first_name="ngModel" ngControl="first_name" name="first_name" class="form-control border-input" placeholder="First Name" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>Last Name</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-user-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.last_name" #last_name="ngModel" ngControl="last_name" name="last_name" class="form-control border-input" placeholder="Last Name" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>Title</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-folder-user-fill"></i>
													</span>
												</div>
												<select class="form-control" [(ngModel)]="lead.title" #title="ngModel" ngControl="title" name="title">
													<option *ngFor="let title of titles" [value]="title">
														{{ title }}
													</option>
												</select>
											</div>
										</div>
									</div>
								</div>

								<div class="row mt-4">
									<div class="col-5">
										<label>Alternate Contact</label>
										<div class="input-group">
											<div class="input-group-prepend">
												<span class="input-group-text">
													<i class="ri-user-fill"></i>
												</span>
											</div>
											<input [(ngModel)]="lead.alt_contact" #last_name="ngModel" ngControl="last_name" name="last_name" class="form-control border-input" placeholder="Name Alternate contact" type="text" />
										</div>
									</div>
									<div class="col-3">
										<div class="form-group">
											<label>Alt Phone</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-phone-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.alt_phone" #alt_phone="ngModel" ngControl="alt_phone" name="alt_phone" class="form-control border-input" type="text" maxlength="10" />
											</div>
										</div>
									</div>
									<div class="col-4">
										<div class="form-group">
											<label>EIN</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-folder-user-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.ein" #ein="ngModel" ngControl="alt_phone" name="alt_phone" class="form-control border-input" type="text" maxlength="100" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>Address 1</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.address_1" #address_1="ngModel" ngControl="address_1" name="address_1" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-4 col-sm-4">
										<div class="form-group">
											<label>Address 2</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.address_2" #address_2="ngModel" ngControl="address_2" name="address_2" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>

									<div class="col-md-4 col-sm-4">
	<label>5500 Form</label>
	<div class="input-group mb-3">
		<input [(ngModel)]="lead.form_5500" type="text" #form_5500="ngModel" class="form-control" placeholder="URL" aria-describedby="button-addon2" name="form_5500" />
		<div class="input-group-append">
			<a href="{{ lead.form_5500 }}" class="btn btn-secondary"
			   [class.disabled]="!lead.form_5500 || lead.form_5500 === 'null'"
			   [attr.aria-disabled]="!lead.form_5500 || lead.form_5500 === 'null'"
			   [attr.tabindex]="(!lead.form_5500 || lead.form_5500 === 'null') ? -1 : null"
			   (click)="(!lead.form_5500 || lead.form_5500 === 'null') && $event.preventDefault()"
			   target="_blank"><i class="ri-share-forward-fill"></i></a>
		</div>
	</div>
</div>
								</div>

								<div class="row mt-4">
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>State</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.state" #state="ngModel" ngControl="state" name="state" class="form-control border-input" type="text" maxlength="2" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Zip</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.zip" #zip="ngModel" ngControl="zip" name="zip" class="form-control border-input" type="text" maxlength="6" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>City</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-map-pin-2-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.city" #city="ngModel" ngControl="city" name="city" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-5 col-sm-5">
										<div class="form-group">
											<label>Additional Info</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-asterisk"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.additional_info" #additional_info="ngModel" ngControl="additional_info" name="additional_info" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4"></div>
							</div>
							<div class="col-md-12 ml-auto mr-auto">
								<div class="row mt-4">
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Direct Line</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-phone-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.direct_line" #direct_line="ngModel" ngControl="direct_line" name="direct_line" class="form-control border-input" placeholder="Direct Line" type="text" maxlength="10" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Mobile Phone</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-smartphone-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.mobile_phone" #mobile_phone="ngModel" ngControl="mobile_phone" name="mobile_phone" class="form-control border-input" placeholder="Mobile" type="text" maxlength="10" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Extension</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-phone-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.ext" #ext="ngModel" ngControl="ext" name="ext" class="form-control border-input" placeholder="Extension" type="text" maxlength="10" />
											</div>
										</div>
									</div>
									<div class="col-md-6 col-sm-6">
										<div class="form-group">
											<label>Website</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-macbook-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.website_url" #website_url="ngModel" ngControl="website_url" name="website_url" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-md-6 col-sm-6">
										<div class="form-group">
											<label>Primary Email</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-mail-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.email" #email="ngModel" ngControl="email" name="email" class="form-control border-input" placeholder="Primary Email" type="email" />
											</div>
										</div>
									</div>
									<div class="col-md-6 col-sm-6">
										<div class="form-group">
											<label>Alt Email</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-mail-line"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.alt_email" #alt_email="ngModel" ngControl="alt_email" name="alt_email" class="form-control border-input" type="email" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4">
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Employee Size</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-team-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.employee_size" #employee_size="ngModel" ngControl="employee_size" name="employee_size" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Annual Revenue</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-money-dollar-box-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.annual_revenue" #annual_revenue="ngModel" ngControl="annual_revenue" name="annual_revenue" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Plan Asset Size</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-money-dollar-box-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.plan_assets" #plan_assets="ngModel" ngControl="plan_assets" name="plan_assets" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Plan Participants</label>

											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-team-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.plan_participants" #plan_participants="ngModel" ngControl="plan_participants" name="plan_participants" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
								</div>
								<div class="row mt-4"></div>
								<div class="row mt-4">
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Provider/Carrier 1</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-bank-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.provider_1" #provider_1="ngModel" ngControl="provider_1" name="provider_1" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Renewal Month</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-calendar-line"></i>
													</span>
												</div>
												<select [(ngModel)]="lead.renewal_month_1" #renewal_month_1="ngModel" ngControl="renewal_month_1" name="renewal_month_1" class="form-control">
													<option value="0">NA</option>
													<option value="1">Jan</option>
													<option value="2">Feb</option>
													<option value="3">Mar</option>
													<option value="4">Apr</option>
													<option value="5">May</option>
													<option value="6">Jun</option>
													<option value="7">Jul</option>
													<option value="8">Aug</option>
													<option value="9">Sep</option>
													<option value="10">Oct</option>
													<option value="11">Nov</option>
													<option value="12">Dec</option>
												</select>
											</div>
										</div>
									</div>
									<div class="col-md-1 col-sm-1">
										<div class="form-group">
											<label>Year</label>
											<div class="input-group">
												<select [(ngModel)]="lead.renewal_year_1" #renewal_year_1="ngModel" ngControl="renewal_year_1" name="renewal_year_1" class="form-control">
													<option value="0">NA</option>
													<option value="2019">19</option>
													<option value="2020">20</option>
													<option value="2021">21</option>
													<option value="2022">22</option>
													<option value="2023">23</option>
													<option value="2024">24</option>
													<option value="2025">25</option>
													<option value="2026">26</option>
													<option value="2027">27</option>
													<option value="2028">28</option>
													<option value="2029">29</option>
													<option value="2030">30</option>
													<option value="2031">31</option>
												</select>
											</div>
										</div>
									</div>
									<div class="col-md-3 col-sm-3">
										<div class="form-group">
											<label>Provider/Carrier 2</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-bank-fill"></i>
													</span>
												</div>
												<input [(ngModel)]="lead.provider_2" #provider_2="ngModel" ngControl="provider_2" name="provider_2" class="form-control border-input" type="text" />
											</div>
										</div>
									</div>
									<div class="col-md-2 col-sm-2">
										<div class="form-group">
											<label>Renewal Month</label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">
														<i class="ri-calendar-line"></i>
													</span>
												</div>
												<select [(ngModel)]="lead.renewal_month_2" #renewal_month_2="ngModel" ngControl="renewal_month_2" name="renewal_month_2" class="form-control">
													<option value="0">NA</option>
													<option value="1">Jan</option>
													<option value="2">Feb</option>
													<option value="3">Mar</option>
													<option value="4">Apr</option>
													<option value="5">May</option>
													<option value="6">Jun</option>
													<option value="7">Jul</option>
													<option value="8">Aug</option>
													<option value="9">Sep</option>
													<option value="10">Oct</option>
													<option value="11">Nov</option>
													<option value="12">Dec</option>
												</select>
											</div>
										</div>
									</div>
									<div class="col-md-1 col-sm-1">
										<div class="form-group">
											<label>Year</label>
											<div class="input-group">
												<select [(ngModel)]="lead.renewal_year_2" #renewal_year_2="ngModel" ngControl="renewal_year_2" name="renewal_year_2" class="form-control">
													<option value="0">NA</option>
													<option value="2019">19</option>
													<option value="2020">20</option>
													<option value="2021">21</option>
													<option value="2022">22</option>
													<option value="2023">23</option>
													<option value="2024">24</option>
													<option value="2025">25</option>
													<option value="2026">26</option>
													<option value="2027">27</option>
													<option value="2028">28</option>
													<option value="2029">29</option>
													<option value="2030">30</option>
													<option value="2031">31</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-12 col-sm-12">
								<!-- LABEL AND BUTTON COPY -->
								<div class="row mt-4" style="margin-bottom: 5px">
									<div class="col-6">
										<label style="display: inline-block">Lead Notes - User => {{ lead.generated_by }}</label>
									</div>
									<div class="col-6" align="right">
										<button class="btn btn-info btn-sm" style="display: inline-block" (click)="copyMessage(lead.notes)">Click to copy <i class="fa fa-files-o" aria-hidden="true"></i></button>
									</div>
								</div>

								<div class="row">
									<div class="col-12">
										<div class="form-group">
											<textarea [(ngModel)]="lead.notes" #notes ngControl="notes" value="Si se copio" name="notes" class="form-control money-green notes-box" rows="5" placeholder="Enter Notes Here..." disabled *ngIf="user.isClient != 1"></textarea>
										</div>
									</div>
								</div>

								<div *ngIf="notes.length == 0 || notes == null || notes == undefined">There is no notes</div>
							</div>

							<div class="col-md-12 col-sm-12" *ngIf="lead.comments_request != ''">
								<div class="row">
									<div class="col-12">
										<p>Comments request</p>
									</div>
								</div>
								<div class="row">
									<div class="col-12">
										<div class="form-group">
											<textarea style="background-color: beige" [(ngModel)]="lead.comments_request" #notes ngControl="notes" value="Si se copio" name="notes" class="form-control notes-box" rows="5" placeholder="Enter Notes Here..." disabled></textarea>
										</div>
									</div>
								</div>
							</div>

							<div class="col-md-12 col-sm-12" style="cursor: pointer" (click)="reschedule_reason_display ? (reschedule_reason_display = false) : (reschedule_reason_display = true)">
								<span>Reschedule reason</span>
								<span><i class="fa" aria-hidden="true" [ngClass]="reschedule_reason_display ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
								<hr />
							</div>
							<div class="col-md-12 col-sm-12" *ngIf="reschedule_reason_display">
								<div class="form-group">
									<textarea [(ngModel)]="lead.reschedule_reason" #notes="ngModel" ngControl="notes" name="notes" class="form-control light-gray notes-box" rows="5" placeholder="Reschedule Reason" disabled></textarea>
								</div>
							</div>

							<div class="col-md-12 col-sm-12" style="cursor: pointer" (click)="client_feedback_display ? (client_feedback_display = false) : (client_feedback_display = true)">
								<span>Client Feedback</span>
								<span><i class="fa" aria-hidden="true" [ngClass]="client_feedback_display ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
								<hr />
							</div>
							<div class="col-md-12 col-sm-12" *ngIf="client_feedback_display">
								<div class="form-group">
									<textarea [(ngModel)]="lead.client_feedback" #notes="ngModel" ngControl="notes" name="notes" class="form-control light-yellow notes-box" rows="5" placeholder="Reschedule Reason" disabled></textarea>
								</div>
							</div>
							<div class="col-md-12 col-sm-12" style="cursor: pointer" (click)="client_notes_display ? (client_notes_display = false) : (client_notes_display = true)">
								<span>Client notes</span>
								<span><i class="fa" aria-hidden="true" [ngClass]="client_notes_display ? 'fa-chevron-up' : 'fa-chevron-down'"></i></span>
								<hr />
							</div>
							<div class="col-md-12 col-sm-12" *ngIf="client_notes_display">
								<ngx-simplebar class="px-3 mx-n3 mb-2" *ngFor="let item of client_notes">
									<div class="d-flex mb-4">
										<div *ngIf="item.client == 1" class="flex-grow-1 ms-3">
											<h5 class="fs-13">
												<img src="assets/images/users/avatar-c.png" alt="" class="avatar-xs rounded-circle" />
												Client comment<small class="text-muted">| {{ item.date }}</small>
											</h5>
											<p class="text-muted">{{ item.note }}</p>
										</div>
										<div *ngIf="item.client == 0" class="flex-grow-1 ms-3">
											<h5 class="fs-13">
												<img src="assets/images/users/avatar-qc.png" alt="" class="avatar-xs rounded-circle" />
												QC response <small class="text-muted"> | {{ item.date }}</small>
											</h5>
											<p class="text-muted">{{ item.note }}</p>
										</div>
									</div>
								</ngx-simplebar>

								<div class="mt-4 col-lg-10" *ngIf="messageSuccess != ''">
									<app-success-msg [msg]="messageSuccess"></app-success-msg>
								</div>

								<form (ngSubmit)="submitNotes()" class="mt-4">
									<div class="row g-3">
										<div class="col-lg-12">
											<label for="exampleFormControlTextarea1" class="form-label">Reply Notes</label>
											<textarea class="form-control bg-light border-light" name="client_notes_area" id="client_notes_area" [(ngModel)]="formData.client_notes_area" rows="3" rows="5" placeholder="Write your answer ..."></textarea>
										</div>
										<div class="col-12 text-end">
											<button class="btn btn-success" type="submit">
												<i *ngIf="loadingSaveNote == false" class="bx bx-save align-bottom me-1"></i>
												<div *ngIf="loadingSaveNote" class="spinner-border spinner-border-sm text-light" role="status">
													<span class="sr-only">Loading...</span>
												</div>
												Save Response
											</button>
										</div>
									</div>
								</form>
							</div>
						</ng-container>

						<ng-container *ngIf="activeTab === 'call_sheet'">
							<div *ngIf="camapignInfoLoading">
								<app-loading></app-loading>
							</div>

							<div *ngIf="!camapignInfoLoading && campaign_info" class="col-md-12 ml-auto mr-auto mb-3" style="margin-top: 20px">
								<ul role="tablist" class="nav nav-pills justify-content-start">
									<li class="nav-item">
										<span (click)="callSheetTab = 'bio'" [class.active]="callSheetTab === 'bio'" class="nav-link profile-tab-btn info-toggle" role="tab" aria-expanded="true"> Bio/Script </span>
									</li>
									<li class="nav-item">
										<span (click)="callSheetTab = 'details'" [class.active]="callSheetTab === 'details'" class="nav-link profile-tab-btn info-toggle" role="tab" aria-expanded="false"> Details </span>
									</li>
								</ul>
							</div>

							<ng-container *ngIf="!camapignInfoLoading && campaign_info && callSheetTab === 'bio'">
								<div class="col-md-12 ml-auto mr-auto">
									<div *ngIf="campaign_info.script" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Sample Script</label>
												<div class="value-txt">
													{{ campaign_info.script }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Who We Are</label>
												<div class="value-txt">
													{{ campaign_info.who_we_are }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">What We Do</label>
												<div class="value-txt">
													{{ campaign_info.what_we_do }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Why Us</label>
												<div class="value-txt">
													{{ campaign_info.why_us }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</ng-container>
							<ng-container *ngIf="!camapignInfoLoading && campaign_info && callSheetTab === 'details'">
								<div class="col-md-12 ml-auto mr-auto">
									<div *ngIf="campaign_info.notes" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Special Notes</label>
												<div class="value-txt text-danger">
													{{ campaign_info.notes }}
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="campaign_info.questions" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Qualifying Questions</label>
												<div class="value-txt text-danger">
													{{ campaign_info.questions }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div *ngIf="campaign_info.employee_size_min && campaign_info.employee_size_min > 0" class="col-md-3 col-sm-3">
											<div class="form-group">
												<label class="call-sheet-title">Employee Size Min</label>
												<div class="value-txt">
													{{ campaign_info.employee_size_min | number : ".0" }}
												</div>
											</div>
										</div>
										<div *ngIf="campaign_info.employee_size_max && campaign_info.employee_size_max > 0" class="col-md-3 col-sm-3">
											<div class="form-group">
												<label class="call-sheet-title">Employee Size Max</label>
												<div class="value-txt">
													{{ campaign_info.employee_size_max | number : ".0" }}
												</div>
											</div>
										</div>
										<div *ngIf="campaign_info.asset_size_min && campaign_info.asset_size_min > 0" class="col-md-3 col-sm-3">
											<div class="form-group">
												<label class="call-sheet-title">Plan Asset Size Min</label>
												<div class="value-txt">
													{{ campaign_info.asset_size_min | currency }}
												</div>
											</div>
										</div>
										<div *ngIf="campaign_info.asset_size_max && campaign_info.asset_size_max > 0" class="col-md-3 col-sm-3">
											<div class="form-group">
												<label class="call-sheet-title">Plan Asset Size Max</label>
												<div class="value-txt">
													{{ campaign_info.asset_size_max | currency }}
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="campaign_info.additional_calendar_url" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Additional Calendar</label>
												<div class="value-txt">
													<a class="text-danger" [href]="campaign_info.additional_calendar_url" target="_blank">
														{{ campaign_info.additional_calendar_url }}
													</a>
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="campaign_info.scheduling" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Scheduling</label>
												<div class="value-txt text-danger">
													{{ campaign_info.scheduling }}
												</div>
											</div>
										</div>
									</div>
									<div *ngIf="campaign_info.zip_codes_to_include === '1'" class="row">
										<div class="col-md-12 col-sm-12">
											<div class="form-group">
												<label class="call-sheet-title">Acceptable Zip Codes</label>
												<ul role="tablist" class="nav nav-pills justify-content-start">
													<li class="nav-item">
														<span (click)="showZipCodes = false" [class.active]="!showZipCodes" class="nav-link profile-tab-btn show-toggle" role="tab" aria-expanded="true" aria-="false" aria-controls="ngb-tab-5-panel"> Hide </span>
													</li>
													<li class="nav-item">
														<span (click)="showZipCodes = true" [class.active]="showZipCodes" class="nav-link profile-tab-btn show-toggle" role="tab" aria-expanded="false" aria-="false"> Show </span>
													</li>
												</ul>
												<div *ngIf="showZipCodes" class="value-txt">
													{{ campaign_info.zip_codes }}
												</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-md-6 col-sm-6">
											<div class="form-group">
												<label class="call-sheet-title">Who's Attending the Meetings?</label>
												<div class="value-txt">
													{{ campaign_info.attending }}
												</div>
											</div>
										</div>
										<div class="col-md-6 col-sm-6">
											<div class="form-group">
												<label class="call-sheet-title">Type of Meeting</label>
												<div class="value-txt">
													{{ campaign_info.type }}
												</div>
											</div>
										</div>
									</div>
									<br />
								</div>
							</ng-container>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
